const determineOptimiseRxBannerIcon = (result) => {
  switch (determineOptimiseRxBannerType(result)) {
    case "danger":
      return "fa-solid fa-ban";
  }

  return undefined;
};

const determineOptimiseRxBannerType = (result) => {
  let bannerType = "info";

  result.metaDataItems?.forEach((metaDataItem) => {
    if ("danger" === metaDataItem.bannerType) {
      bannerType = "danger";
    } else if ("warning" === metaDataItem.bannerType && "info" === bannerType) {
      bannerType = "warning";
    }
  });

  return bannerType;
};

const determineOptimiseRxResultHasMetaDataType = (result, type) => {
  let containsMetaDataType = false;

  result.metaDataItems?.forEach((metaDataItem) => {
    if (type === metaDataItem.rawType) {
      containsMetaDataType = true;
    }

    /* @todo [Jack] ENG-16951 Determination of metadata types TBC */
    if (type === metaDataItem.inferredAction) {
      // containsMetaDataType = true;
    }
  });

  return containsMetaDataType;
};

const determineOptimiseRxBannerPosition = (result /*, metaDataItem*/) => {
  if (result.isSwap) {
    return "issue-quantity";
  }

  if (result.isComplex && determineOptimiseRxResultHasMetaDataType(result, "Do not prescribe")) {
    return "product";
  }

  if (result.isComplex && determineOptimiseRxResultHasMetaDataType(result, "Co-prescribe")) {
    return "product";
  }

  if (result.isComplex && result.alternatives?.length > 0) {
    return "product";
  }

  if (
    result.isComplex &&
    determineOptimiseRxResultHasMetaDataType(result, "Best Practice") &&
    determineOptimiseRxResultHasMetaDataType(result, "Prescribe Alternative")
  ) {
    return "product";
  }

  if (
    result.isComplex &&
    determineOptimiseRxResultHasMetaDataType(result, "Rx Budget") &&
    determineOptimiseRxResultHasMetaDataType(result, "Prescribe Alternative")
  ) {
    return "product";
  }

  if (result.isComplex && determineOptimiseRxResultHasMetaDataType(result, "Formulary")) {
    return "right-hand-side";
  }

  if (result.isComplex && determineOptimiseRxResultHasMetaDataType(result, "Cost")) {
    return "right-hand-side";
  }

  if (result.isComplex && determineOptimiseRxResultHasMetaDataType(result, "Information")) {
    return "right-hand-side";
  }

  return "right-hand-side";
};

export {
  determineOptimiseRxBannerIcon,
  determineOptimiseRxBannerType,
  determineOptimiseRxResultHasMetaDataType,
  determineOptimiseRxBannerPosition,
};
